import { BaseComponent } from './BaseComponent';
import { Announcement } from '../types';
import { Config } from '../core/Config';
import { getTypeIcon } from '../utils/icons';

export class TopBar extends BaseComponent {
    private announcement: Announcement;
    private onClose: () => void;
    private onReadMore: () => void;

    constructor(
        config: Config,
        announcement: Announcement,
        onClose: () => void,
        onReadMore: () => void
    ) {
        super(config);
        this.announcement = announcement;
        this.onClose = onClose;
        this.onReadMore = onReadMore;
    }

    protected render(): HTMLElement {
        const topBar = this.createElement('div', 'pr-topbar pr-sdk');
        topBar.setAttribute('role', 'banner');
        topBar.setAttribute('aria-label', 'Announcement');

        const content = this.createElement('div', 'pr-topbar-content');

        // Add type icon (outline SVG that inherits the bar's text color)
        const typeIcon = this.createElement('span', 'pr-topbar-icon');
        typeIcon.innerHTML = getTypeIcon(this.announcement.type);
        typeIcon.setAttribute('aria-hidden', 'true');
        content.appendChild(typeIcon);

        const title = this.createElement('h3', 'pr-topbar-title');
        title.textContent = this.announcement.title;
        content.appendChild(title);

        const link = this.createElement('a', 'pr-topbar-link');
        link.textContent = this.config.t.readMore;
        link.href = '#';
        link.onclick = (e) => {
            e.preventDefault();
            this.handleReadMore();
        };
        content.appendChild(link);

        topBar.appendChild(content);

        const closeBtn = this.createElement('button', 'pr-topbar-close');
        closeBtn.innerHTML = '&times;';
        closeBtn.setAttribute('aria-label', this.config.t.close);
        closeBtn.onclick = () => this.handleClose();
        topBar.appendChild(closeBtn);

        return topBar;
    }

    protected closeOnEscape(): boolean {
        return true;
    }

    protected onEscape(): void {
        this.handleClose();
    }

    private handleClose(): void {
        this.hide();
        this.onClose();
    }

    private handleReadMore(): void {
        this.onReadMore();
    }
}
